import { notNull } from '../utils'
import countryList, { CountryCode, CurrencyCode, countryCodeEnum, getCountryCodeBasedOnTimezone } from './countryList'
import TimeZone from './TimeZone'

export const fallbackOrgCountryCode: CountryCode = 'NZ'

export type OrgCountryAndCurrency = { countryCode: CountryCode; currencyCode: CurrencyCode }

export const isCountryCode = (value: unknown): value is CountryCode =>
   typeof value === 'string' && (countryCodeEnum as readonly string[]).includes(value)

export const getDefaultCurrencyCodeForCountry = (countryCode: CountryCode): CurrencyCode =>
   notNull(countryList.find(country => country.code === countryCode)).defaultCurrency.code

export const getCountryCodeFromTimeZone = (timeZone: string | null | undefined): CountryCode | null =>
   timeZone ? getCountryCodeBasedOnTimezone(timeZone as TimeZone) : null

/** Explicit country wins, then the browser timezone, then NZ; the currency is always the country's default. */
export const resolveOrgCountryAndCurrency = (params: { countryCode?: string | null; timeZone?: string | null }): OrgCountryAndCurrency => {
   const countryCode = isCountryCode(params.countryCode) ? params.countryCode : getCountryCodeFromTimeZone(params.timeZone) ?? fallbackOrgCountryCode
   return { countryCode, currencyCode: getDefaultCurrencyCodeForCountry(countryCode) }
}
